import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'queries';

export default {
  state: {
    all: [],
    current: null
  },

  mutations: {
    setAllQueries(state, queries) {
      state.all = queries;
    },

    setCurrentQuery(state, query) {
      state.current = query;

      // ensure the field and options are defaulted to empty strings
      state.current.matchers = _.map(state.current.matchers, (matcher) => {
        matcher.field = matcher.field || "";
        matcher.options = matcher.options || "";

        return matcher;
      });

      // defaults
      state.current.on_match.responses = state.current.on_match.responses || [];
      state.current.on_match.setters = state.current.on_match.setters || [];
      state.current.on_match.form_fields = state.current.on_match.form_fields || [];
      state.current.on_mismatch.responses = state.current.on_mismatch.responses || [];
      state.current.on_mismatch.setters = state.current.on_mismatch.setters || [];
      state.current.on_mismatch.form_fields = state.current.on_mismatch.form_fields || [];
    },

    addQuery(state, query) {
      state.all.push(query);
    },

    updateQuery(state, query) {
      state.all = _.map(state.all, (q) => {
        if (q.id !== query.id) return q;
        return query;
      });
    }
  },

  actions: {
    fetchQueries({ commit }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          commit(
            "setAllQueries",
            _.map(resp.data.data, (cat) => cat.attributes)
          );
        })
        .catch((err) => console.error("Failed to fetch queries", err));
    },

    changeCurrentQuery({ commit, state }, queryId) {
      const query = _.findWhere(state.all, { id: parseInt(queryId) });
      commit("setCurrentQuery", query);

      return query;
    },

    createQuery({ commit }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          commit("addQuery", resp.data.data.attributes);
          return resp;
        });
    },

    updateQuery({ commit }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}`, params)
        .then((resp) => {
          commit("updateQuery", resp.data.data.attributes);
        });
    }
  }
};
